import { useEffect } from 'react';
import { isBrowser } from '../../util/routeUtils';

function useCMSInjectedScript() {
  useEffect(() => {
    if (!isBrowser()) return;
    const cmsInjectUrl = (window as any)?.env?.CMS_INJECT || '';
    const scriptId = 'cms-injected-script';
    const appendCMSScript = () => {
      if (cmsInjectUrl && !document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.src = cmsInjectUrl;
        script.async = true;
        script.id = scriptId;
        script.onload = () => {
          console.log(`${scriptId} loaded successfully`);
        };
        script.onerror = () => console.error(`Failed to load ${scriptId}`);
        document.body.appendChild(script);
      }
    };

    if (document.readyState === 'complete') {
      appendCMSScript();
    } else {
      // The 'once' option auto-removes this event listener after it runs.
      window.addEventListener('load', appendCMSScript, { once: true });
    }

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        console.log('Removing cms-injected-script');
        existingScript.remove();
      }
    };
  }, []);
}

export default useCMSInjectedScript;
